import ContactForm from "../contactform";
import { useEffect } from "react";
import { motion } from "framer-motion";
const CaseForm = () => {

    useEffect(() => {
        // Scroll to the top of the page when the component loads
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, []);

    return (

        <motion.div
        className="mt-20"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >

       <div className="mt-28">
        <h2 className="font-bold">SUBMIT A CASE</h2>
        <h5 className="font-bold" >Ready to Take Action?</h5>
        <p>Fill out the form below to get started. Don’t worry, it’s quick and simple – we’ll handle the legal side so you don’t have to.

</p>
        <ContactForm/>
       </div>
       </motion.div>
       
    )}
export default CaseForm;